import { getAssignmentById, updateAssignment } from '../../../service';

// Read the current assignment before replacing its question so rubric selections,
// course materials and settings saved elsewhere survive a trip back through step 1.
export const saveDraftQuestion = async (assignmentId, form, queryClient, expectedTitle) => {
  if (expectedTitle === undefined) {
    throw new Error('Reopen this draft before saving its question.');
  }
  const assignment = await getAssignmentById(assignmentId);
  if (assignment?.id !== assignmentId || !assignment.questions?.length) {
    throw new Error('This draft could not be loaded. Please try again.');
  }
  const question = {
    ...assignment.questions[0],
    question: form.question,
    stimulusText: form.stimulusText || '',
    stimulusFiles: form.stimulusFiles || [],
  };
  const saved = await updateAssignment(assignmentId, {
    ...assignment,
    title: form.title,
    // The fresh read preserves other fields, but cannot grant consent to
    // overwrite a title changed after this form was opened.
    expectedTitle,
    questions: [question, ...assignment.questions.slice(1)],
  }, { throwOnError: true });
  if (saved?.id !== assignmentId) throw new Error('Your question could not be saved. Please try again.');
  if (queryClient) {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ['assignment', assignmentId] }),
      queryClient.invalidateQueries({ queryKey: ['assignmentById', assignmentId] }),
    ]);
  }
  return assignmentId;
};
